module.exports = {
	"datas": [
		{
			"anime_id": 23,
			"anime_title": "DARLING in the FRANXX",
			"id": 40,
			"title": "02"
		},
		{
			"anime_id": 23,
			"anime_title": "DARLING in the FRANXX",
			"id": 76,
			"title": "莓"
		},
		{
			"anime_id": 23,
			"anime_title": "DARLING in the FRANXX",
			"id": 110,
			"title": "未来"
		},
		{
			"anime_id": 23,
			"anime_title": "DARLING in the FRANXX",
			"id": 142,
			"title": "心"
		},
		{
			"anime_id": 23,
			"anime_title": "DARLING in the FRANXX",
			"id": 178,
			"title": "郁乃"
		},
		{
			"anime_id": 21,
			"anime_title": "pop子和pipi美的日常",
			"id": 38,
			"title": "ポプ子"
		},
		{
			"anime_id": 21,
			"anime_title": "pop子和pipi美的日常",
			"id": 74,
			"title": "ピピ美"
		},
		{
			"anime_id": 25,
			"anime_title": "魔卡少女樱 CLEAR CARD篇",
			"id": 42,
			"title": "木之本樱"
		},
		{
			"anime_id": 25,
			"anime_title": "魔卡少女樱 CLEAR CARD篇",
			"id": 78,
			"title": "大道寺知世"
		},
		{
			"anime_id": 25,
			"anime_title": "魔卡少女樱 CLEAR CARD篇",
			"id": 111,
			"title": "诗之本秋穗"
		},
		{
			"anime_id": 19,
			"anime_title": "摇曳露营△",
			"id": 36,
			"title": "各务原抚子"
		},
		{
			"anime_id": 19,
			"anime_title": "摇曳露营△",
			"id": 71,
			"title": "志摩凛"
		},
		{
			"anime_id": 19,
			"anime_title": "摇曳露营△",
			"id": 72,
			"title": "大垣千明"
		},
		{
			"anime_id": 19,
			"anime_title": "摇曳露营△",
			"id": 105,
			"title": "犬山葵"
		},
		{
			"anime_id": 19,
			"anime_title": "摇曳露营△",
			"id": 106,
			"title": "齐藤惠那"
		},
		{
			"anime_id": 2,
			"anime_title": "citrus～柑橘味香气～",
			"id": 4,
			"title": "蓝原柚子"
		},
		{
			"anime_id": 2,
			"anime_title": "citrus～柑橘味香气～",
			"id": 15,
			"title": "蓝原芽衣"
		},
		{
			"anime_id": 2,
			"anime_title": "citrus～柑橘味香气～",
			"id": 43,
			"title": "谷口晴美"
		},
		{
			"anime_id": 2,
			"anime_title": "citrus～柑橘味香气～",
			"id": 79,
			"title": "桃木野姬子"
		},
		{
			"anime_id": 2,
			"anime_title": "citrus～柑橘味香气～",
			"id": 113,
			"title": "水泽茉莉"
		},
		{
			"anime_id": 7,
			"anime_title": "龙王的工作！",
			"id": 10,
			"title": "雏鹤爱"
		},
		{
			"anime_id": 7,
			"anime_title": "龙王的工作！",
			"id": 25,
			"title": "夜叉神天衣"
		},
		{
			"anime_id": 7,
			"anime_title": "龙王的工作！",
			"id": 61,
			"title": "空银子"
		},
		{
			"anime_id": 7,
			"anime_title": "龙王的工作！",
			"id": 96,
			"title": "清泷桂香"
		},
		{
			"anime_id": 7,
			"anime_title": "龙王的工作！",
			"id": 128,
			"title": "水越澪"
		},
		{
			"anime_id": 7,
			"anime_title": "龙王的工作！",
			"id": 158,
			"title": "贞任绫乃"
		},
		{
			"anime_id": 7,
			"anime_title": "龙王的工作！",
			"id": 193,
			"title": "夏绿蒂·伊索亚尔"
		},
		{
			"anime_id": 14,
			"anime_title": "爱吃拉面的小泉同学",
			"id": 29,
			"title": "小泉同学"
		},
		{
			"anime_id": 14,
			"anime_title": "爱吃拉面的小泉同学",
			"id": 66,
			"title": "大泽悠"
		},
		{
			"anime_id": 14,
			"anime_title": "爱吃拉面的小泉同学",
			"id": 100,
			"title": "中村美沙"
		},
		{
			"anime_id": 14,
			"anime_title": "爱吃拉面的小泉同学",
			"id": 132,
			"title": "高桥润"
		},
		{
			"anime_id": 15,
			"anime_title": "紫罗兰永恒花园",
			"id": 30,
			"title": "薇尔莉特·伊芙加登"
		},
		{
			"anime_id": 15,
			"anime_title": "紫罗兰永恒花园",
			"id": 67,
			"title": "嘉德丽雅·波德莱尔"
		},
		{
			"anime_id": 15,
			"anime_title": "紫罗兰永恒花园",
			"id": 101,
			"title": "埃丽卡·布朗"
		},
		{
			"anime_id": 15,
			"anime_title": "紫罗兰永恒花园",
			"id": 133,
			"title": "艾丽斯·卡纳利"
		},
		{
			"anime_id": 15,
			"anime_title": "紫罗兰永恒花园",
			"id": 251,
			"title": "露库莉娅·马尔博罗"
		},
		{
			"anime_id": 17,
			"anime_title": "擅长捉弄的高木同学",
			"id": 32,
			"title": "高木"
		},
		{
			"anime_id": 11,
			"anime_title": "Slow Start",
			"id": 18,
			"title": "一之濑花名"
		},
		{
			"anime_id": 11,
			"anime_title": "Slow Start",
			"id": 52,
			"title": "百地玉手"
		},
		{
			"anime_id": 11,
			"anime_title": "Slow Start",
			"id": 87,
			"title": "十仓荣依子"
		},
		{
			"anime_id": 11,
			"anime_title": "Slow Start",
			"id": 121,
			"title": "千石冠"
		},
		{
			"anime_id": 32,
			"anime_title": "OVERLORD 第二季",
			"id": 53,
			"title": "雅儿贝德"
		},
		{
			"anime_id": 32,
			"anime_title": "OVERLORD 第二季",
			"id": 88,
			"title": "ツアレ"
		},
		{
			"anime_id": 32,
			"anime_title": "OVERLORD 第二季",
			"id": 122,
			"title": "夏提雅・布拉德弗伦"
		},
		{
			"anime_id": 32,
			"anime_title": "OVERLORD 第二季",
			"id": 239,
			"title": "娜贝拉尔・迦玛"
		},
		{
			"anime_id": 32,
			"anime_title": "OVERLORD 第二季",
			"id": 281,
			"title": "索留香・艾普西隆"
		},
		{
			"anime_id": 32,
			"anime_title": "OVERLORD 第二季",
			"id": 300,
			"title": "艾多玛・巴西丽莎・泽塔"
		},
		{
			"anime_id": 32,
			"anime_title": "OVERLORD 第二季",
			"id": 334,
			"title": "拉娜·提耶儿·夏尔敦·莱儿·凡瑟芙"
		},
		{
			"anime_id": 4,
			"anime_title": "粗点心战争2",
			"id": 6,
			"title": "枝垂萤"
		},
		{
			"anime_id": 4,
			"anime_title": "粗点心战争2",
			"id": 19,
			"title": "远藤沙耶"
		},
		{
			"anime_id": 6,
			"anime_title": "爆肝工程师的异世界狂想曲",
			"id": 8,
			"title": "洁娜·马利安泰鲁"
		},
		{
			"anime_id": 6,
			"anime_title": "爆肝工程师的异世界狂想曲",
			"id": 9,
			"title": "波奇"
		},
		{
			"anime_id": 6,
			"anime_title": "爆肝工程师的异世界狂想曲",
			"id": 23,
			"title": "小玉"
		},
		{
			"anime_id": 6,
			"anime_title": "爆肝工程师的异世界狂想曲",
			"id": 24,
			"title": "莉萨"
		},
		{
			"anime_id": 6,
			"anime_title": "爆肝工程师的异世界狂想曲",
			"id": 59,
			"title": "亚里沙"
		},
		{
			"anime_id": 6,
			"anime_title": "爆肝工程师的异世界狂想曲",
			"id": 60,
			"title": "露露"
		},
		{
			"anime_id": 6,
			"anime_title": "爆肝工程师的异世界狂想曲",
			"id": 94,
			"title": "蜜雅"
		},
		{
			"anime_id": 6,
			"anime_title": "爆肝工程师的异世界狂想曲",
			"id": 95,
			"title": "娜娜"
		},
		{
			"anime_id": 1,
			"anime_title": "三颗星彩色冒险",
			"id": 1,
			"title": "赤松结衣"
		},
		{
			"anime_id": 1,
			"anime_title": "三颗星彩色冒险",
			"id": 2,
			"title": "小幸"
		},
		{
			"anime_id": 1,
			"anime_title": "三颗星彩色冒险",
			"id": 3,
			"title": "琴叶"
		},
		{
			"anime_id": 3,
			"anime_title": "刀使的巫女",
			"id": 5,
			"title": "卫藤可奈美"
		},
		{
			"anime_id": 3,
			"anime_title": "刀使的巫女",
			"id": 16,
			"title": "十条姬和"
		},
		{
			"anime_id": 3,
			"anime_title": "刀使的巫女",
			"id": 48,
			"title": "柳濑舞衣"
		},
		{
			"anime_id": 3,
			"anime_title": "刀使的巫女",
			"id": 84,
			"title": "丝见沙耶香"
		},
		{
			"anime_id": 3,
			"anime_title": "刀使的巫女",
			"id": 117,
			"title": "益子薰"
		},
		{
			"anime_id": 3,
			"anime_title": "刀使的巫女",
			"id": 147,
			"title": "古波藏爱莲"
		},
		{
			"anime_id": 3,
			"anime_title": "刀使的巫女",
			"id": 182,
			"title": "折神紫"
		},
		{
			"anime_id": 3,
			"anime_title": "刀使的巫女",
			"id": 207,
			"title": "狮童真希"
		},
		{
			"anime_id": 3,
			"anime_title": "刀使的巫女",
			"id": 237,
			"title": "此花寿寿花"
		},
		{
			"anime_id": 3,
			"anime_title": "刀使的巫女",
			"id": 260,
			"title": "皋月夜见"
		},
		{
			"anime_id": 3,
			"anime_title": "刀使的巫女",
			"id": 280,
			"title": "燕结芽"
		},
		{
			"anime_id": 5,
			"anime_title": "酒鬼妹子",
			"id": 7,
			"title": "天月满"
		},
		{
			"anime_id": 5,
			"anime_title": "酒鬼妹子",
			"id": 21,
			"title": "桐山直"
		},
		{
			"anime_id": 5,
			"anime_title": "酒鬼妹子",
			"id": 57,
			"title": "桐山真"
		},
		{
			"anime_id": 5,
			"anime_title": "酒鬼妹子",
			"id": 92,
			"title": "绿川香枝"
		},
		{
			"anime_id": 9,
			"anime_title": "博多豚骨拉面",
			"id": 12,
			"title": "美咲"
		},
		{
			"anime_id": 10,
			"anime_title": "原书·原书使",
			"id": 17,
			"title": "键村叶月"
		},
		{
			"anime_id": 10,
			"anime_title": "原书·原书使",
			"id": 49,
			"title": "土御門 静"
		},
		{
			"anime_id": 10,
			"anime_title": "原书·原书使",
			"id": 50,
			"title": "加澄有子"
		},
		{
			"anime_id": 13,
			"anime_title": "齐木楠雄的灾难 第二季",
			"id": 26,
			"title": "照桥心美"
		},
		{
			"anime_id": 13,
			"anime_title": "齐木楠雄的灾难 第二季",
			"id": 62,
			"title": "梦原知予"
		},
		{
			"anime_id": 13,
			"anime_title": "齐木楠雄的灾难 第二季",
			"id": 97,
			"title": "目良千里"
		},
		{
			"anime_id": 18,
			"anime_title": "哈库梅伊与蜜珂析",
			"id": 33,
			"title": "哈库梅伊"
		},
		{
			"anime_id": 18,
			"anime_title": "哈库梅伊与蜜珂析",
			"id": 70,
			"title": "蜜珂析"
		},
		{
			"anime_id": 18,
			"anime_title": "哈库梅伊与蜜珂析",
			"id": 104,
			"title": "康居"
		},
		{
			"anime_id": 18,
			"anime_title": "哈库梅伊与蜜珂析",
			"id": 136,
			"title": "千"
		},
		{
			"anime_id": 20,
			"anime_title": "皇帝圣印战记",
			"id": 37,
			"title": "希露卡·梅连提丝"
		},
		{
			"anime_id": 20,
			"anime_title": "皇帝圣印战记",
			"id": 73,
			"title": "爱雪拉"
		},
		{
			"anime_id": 20,
			"anime_title": "皇帝圣印战记",
			"id": 107,
			"title": "普莉希拉"
		},
		{
			"anime_id": 20,
			"anime_title": "皇帝圣印战记",
			"id": 139,
			"title": "玛格丽特·奥狄奥斯"
		},
		{
			"anime_id": 22,
			"anime_title": "比宇宙更远的地方",
			"id": 39,
			"title": "玉木真理"
		},
		{
			"anime_id": 22,
			"anime_title": "比宇宙更远的地方",
			"id": 75,
			"title": "小渊泽报濑"
		},
		{
			"anime_id": 22,
			"anime_title": "比宇宙更远的地方",
			"id": 109,
			"title": "三宅日向"
		},
		{
			"anime_id": 22,
			"anime_title": "比宇宙更远的地方",
			"id": 141,
			"title": "白石结月"
		},
		{
			"anime_id": 29,
			"anime_title": "废柴王子",
			"id": 46,
			"title": "艾妮·伊纳科"
		},
		{
			"anime_id": 31,
			"anime_title": "牙斗",
			"id": 51,
			"title": "宇崎瞳"
		},
		{
			"anime_id": 31,
			"anime_title": "牙斗",
			"id": 86,
			"title": "中西获座"
		},
		{
			"anime_id": 31,
			"anime_title": "牙斗",
			"id": 120,
			"title": "稻叶初"
		},
		{
			"anime_id": 34,
			"anime_title": "七美德",
			"id": 55,
			"title": "米迦勒"
		},
		{
			"anime_id": 34,
			"anime_title": "七美德",
			"id": 90,
			"title": "乌列尔"
		},
		{
			"anime_id": 34,
			"anime_title": "七美德",
			"id": 124,
			"title": "沙利叶"
		},
		{
			"anime_id": 34,
			"anime_title": "七美德",
			"id": 154,
			"title": "圣德芬"
		},
		{
			"anime_id": 34,
			"anime_title": "七美德",
			"id": 188,
			"title": "梅塔特隆"
		},
		{
			"anime_id": 34,
			"anime_title": "七美德",
			"id": 215,
			"title": "拉斐尔"
		},
		{
			"anime_id": 34,
			"anime_title": "七美德",
			"id": 241,
			"title": "加百列"
		},
		{
			"anime_id": 37,
			"anime_title": "恋如雨止",
			"id": 93,
			"title": "橘晶"
		},
		{
			"anime_id": 39,
			"anime_title": "七大罪 戒律的复活",
			"id": 155,
			"title": "伊丽莎白·里昂尼丝"
		},
		{
			"anime_id": 39,
			"anime_title": "七大罪 戒律的复活",
			"id": 217,
			"title": "黛安"
		},
		{
			"anime_id": 39,
			"anime_title": "七大罪 戒律的复活",
			"id": 287,
			"title": "玛琳"
		},
		{
			"anime_id": 41,
			"anime_title": "IDOLiSH7",
			"id": 216,
			"title": "小鸟游纺"
		},
		{
			"anime_id": 43,
			"anime_title": "Fate/新章 最终回响",
			"id": 264,
			"title": "尼禄·克劳狄乌斯"
		},
		{
			"anime_id": 43,
			"anime_title": "Fate/新章 最终回响",
			"id": 283,
			"title": "远坂凛"
		},
		{
			"anime_id": 43,
			"anime_title": "Fate/新章 最终回响",
			"id": 320,
			"title": "间桐樱"
		}
	]
};


//////////////////
// WEBPACK FOOTER
// ./src/res/res.json
// module id = 284
// module chunks = 0